(function ($) {
    'use strict';
    var ew = {
        init: function () {
            this.onLoad();
            this.winLoad();
            this.resizeListner();
            this.scrollListner();
            this.navToggle();
            this.scrollAnimation();
            this.tab();
            this.accordion();
            this.slider();
            this.productSticky();
            this.popup();
            this.homeSticky();
            this.sliderScroll();
        },
        settings: {
            windowWidth: $(window).width(),
            windowheight: $(window).height(),
            scrollClassTrigger: 50
        },
        onLoad: function () {
            $(document).ready(function () {});
        },

        winLoad: function () {
            $(window).on('load', function () {
                $('body').addClass('all-loaded');
            });
        },

        resizeListner: function () {
            $(window).on('load resize', function () {
                ew.settings.windowWidth = $(window).width();
            });
        },
        // ScrollListner
        scrollListner: function () {
            $(window).on('load scroll', function () {
                if ($(window).scrollTop() > ew.settings.scrollClassTrigger) {
                    $('body').addClass('scrolled');
                } else {
                    $('body').removeClass('scrolled');
                }
            });

            $(window).on('mousewheel DOMMouseScroll', function (event) {
                let wd = event.originalEvent.wheelDelta || -event.originalEvent.detail;
                if (wd < 0) {
                    $('body').removeClass('scrollingUp');
                    $('body').addClass('scrollingDown');
                } else {
                    $('body').removeClass('scrollingDown');
                    $('body').addClass('scrollingUp')
                }
            });
        },
        navToggle: function() {
            $('#js-navbarToggle').on('click', function() {
                var target = $(this).data('target');
                $(target).toggleClass('active');
                $('body').toggleClass('menu--active');
            });
        },
        
        scrollAnimation: function() {
            if (Modernizr.mq('only all and (min-width: 640px)')) {
                gsap.utils.toArray('[data-animation]').forEach(elem => {
                    let elementAnimation = elem.getAttribute('data-animation');
                    let duration = elem.getAttribute('data-duration') ? elem.getAttribute('data-duration') : 1;
                    let delay = elem.getAttribute('data-delay') ? elem.getAttribute('data-delay') : 0;
                    let hook = elem.getAttribute('data-hook') ? elem.getAttribute('data-hook') : 'top center';
                    gsap.set(elem, {paused: true});
                    switch (elementAnimation) {
                        case "fade-in":
                            var anim = gsap.from(elem, { 
                                delay: delay,
                                duration: duration,
                                autoAlpha: 0 
                            });
                        break;
                        case "from-top":
                            var anim = gsap.from(elem, { 
                                y: '-100', 
                                delay: delay,
                                duration: duration,
                                autoAlpha: 0 
                            });
                        break;
                        case "from-bottom":
                            var anim = gsap.from(elem, { 
                                y: '50', 
                                delay: delay,
                                duration: duration,
                                autoAlpha: 0 
                            });
                        break;
                        case "from-left":
                            var anim = gsap.from(elem, { 
                                x: '-100',
                                delay: delay,
                                duration: duration,
                                autoAlpha: 0 
                            });
                        break;
                        case "from-right":
                            var anim = gsap.from(elem, { 
                                x: '100', 
                                delay: delay,
                                duration: duration,
                                autoAlpha: 0
                            });
                        break;
                        case "from-bottom-elements-lazy":
                            var anim = gsap.from(elem.children, { 
                                y: '50', 
                              	stagger: 0.25,
                                delay: delay,
                                duration: duration,
                                autoAlpha: 0,
                                ease: 'power2.out'
                            });
                        break;
                        default:
                    }
                    ScrollTrigger.create({
                        trigger: elem,
                        start: hook,
                        animation: anim,
                        // markers: true,
                        onEnter: () => {
                        }
                    });
                });
            }
        },

        tab: function() {
            $('.tab__nav-dropdown').on('click', function() {
                let $this = $(this);
                $this.toggleClass('opened');
                $('.tab__nav').toggleClass('active');
            });

            $('.tab__nav li').on('click', function(){
                let $this = $(this);
                let tab_id = $this.attr('data-tab');
                let tab_text = $this.text();
                $('.tab__nav').removeClass('active');
                $('.tab__nav li').removeClass('current');
                $('.tab__content').removeClass('current');
        
                $this.addClass('current');
                $('.tab__nav-dropdown').text(tab_text);
                $("#"+tab_id).addClass('current');
                $("#"+tab_id).find('.accordion-item').eq(0).find('.js-accordion__title').trigger('click');
            });
        },
        accordion: function() {
            $('.js-accordion__title').click(function() {
                if($(this).parent('.accordion-item').hasClass('js-accordion--open')){
                    $('.accordion-item').removeClass('js-accordion--open');
                    $('.accordion__content').slideUp();
                }
                else {
                    $('.accordion__content').slideUp();
                    $('.accordion-item').removeClass('js-accordion--open');
                    $(this).parent('.accordion-item').addClass('js-accordion--open');
                    $(this).parent('.accordion-item').find('.accordion__content').slideDown();
                }
            });
            $('.accordion-item').eq(0).find('.js-accordion__title').trigger('click');
        },
        slider: function() {
            $('.js-slider .slider-wrapper').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                fade: true,
              	asNavFor: '.js-slider .content__slider',
              adaptiveHeight: true,
                  responsive: [
                    {
                      breakpoint: 1199,
                      settings: {
                        adaptiveHeight: true
                      }
                    },
                  ]
            });
            $('.js-slider .content__slider').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                fade: true,
              	asNavFor: '.js-slider .slider-wrapper',
              	arrows: false,
              	dots: false
            });
        },
        productSticky: function() {
            $(window).scroll(function() {
                var section = $('.template-product .product-links');
                if(section.length) {
                    var position = section.offset();
                    var positionTop = position.top - 75;
                    if ($(this).scrollTop() > positionTop){  
                      $('body').addClass("product-sticky");
                    }
                    else{
                      $('body').removeClass("product-sticky");
                    }
                }
              });
        },
        popup: function() {
            $('.open-popup-link').magnificPopup({
                type: 'inline',
                midClick: true,
                mainClass: 'mfp-fade'
              });
        },
        homeSticky: function() {
            var stickySection = document.querySelector(".ew.text-section.text-section--dark-gradient");
            var body = document.querySelector("body");
            if(stickySection){
                var sticky = stickySection.offsetTop -250;
                window.onscroll = function() {homeStickyNav()};
                function homeStickyNav() {
                    if (window.pageYOffset > sticky) {
                        body.classList.add("sticky-home");
                    } else {
                        body.classList.remove("sticky-home");
                    }
                }
            }
            
        },
        sliderScroll: function() {
            if($(window).width()<=1199){
                $('.two-col-feature-section .slick-arrow').on('click', function(event) {
                    var target = $(".two-col-feature-section.js-slider");
                    if( target.length ) {
                        event.preventDefault();
                        $('html, body').stop().animate({
                            scrollTop: target.offset().top - 110
                        }, 1000);
                    }
                });
            }
        }
    };
    ew.init();
}(jQuery));